<template>
    <div>
        <div class="w-full flex justify-center -mb-8">
            <vs-upload
                    action="#"
                    :limit="1"
                    ref="devicesUploader"
                    :show-upload-button="false"
                    text="Добавить файл"
                    @change="changeDevicesFile"
                    @on-delete="deleteDevicesFile"
                    class="w-auto mx-auto"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
        </div>
        <div class="w-full text-center mt-4">
            <vs-button type="border" color="success" @click="importDevices">Загрузить</vs-button>
        </div>
        <div class="w-full text-center mt-4">
            <p>Формат файла - xls, xlsx, csv.</p>
            <p>Скачать пример можно <a href="#">здесь</a></p>
        </div>
        <vs-collapse accordion class="p-0">
            <vs-collapse-item>
                <div slot="header" @click="updateDevicesImportHeight">
                    Доп. настройки
                </div>
                <translit-settings v-model="devicesNeedTranslit"/>
            </vs-collapse-item>
        </vs-collapse>

        <vs-popup :active.sync="isMatchedDevicesOpen" title="Завершение импорта" class="devices-import-matched-answer-popup" v-if="isMatchedDevicesOpen">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <h5 class="mb-4 flex items-center justify-center">
                        Всего приборов в файле: {{matchedDevices.total_devices}}
                    </h5>
                    <h5 class="mb-4 flex items-center">
                        <feather-icon icon="CheckCircleIcon" class="mr-4" svg-classes="text-success"/>
                        Уникальных приборов: {{matchedDevices.unique_qty}}
                    </h5>
                    <vs-collapse accordion class="devices-import-matched-answer-collapse">
                        <vs-collapse-item ref="matchedDevicesCollapse">
                            <div slot="header">
                                <h5 class="flex items-center">
                                    <feather-icon icon="AlertCircleIcon" class="mr-4" svg-classes="text-warning"/>
                                    Найденно совпадающих приборов: {{matchedDevices.matched_qty}}
                                </h5>
                            </div>
                            <vs-table :data="matchedDevices.matched_devices" class="matched-devices-table">
                                <template slot="thead">
                                    <vs-th class="matched-devices-table__td matched-devices-table__td_account-number">Л/С</vs-th>
                                    <vs-th class="matched-devices-table__td matched-devices-table__td_device">Прибор</vs-th>
                                    <vs-th class="matched-devices-table__td matched-devices-table__td_dates">Даты</vs-th>
                                    <vs-th class="matched-devices-table__td matched-devices-table__td_start_value">
                                        <div class="w-full text-center">
                                            Начальное значение
                                        </div>
                                    </vs-th>
                                    <vs-th class="matched-devices-table__td matched-devices-table__td_actions">
                                        <div class="w-full text-center">
                                            Создать
                                        </div>
                                    </vs-th>
                                </template>
                                <template slot-scope="{data}" ref="content">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" ref="deviceTr">
                                        <vs-td class="matched-devices-table__td matched-devices-table__td_account-number">
                                            {{tr.new_device.account_number}}
                                        </vs-td>
                                        <vs-td class="matched-devices-table__td matched-devices-table__td_device">
                                            <div class="matched-device-info">
                                                <div class="matched-device-info__header">
                                                    <feather-icon v-if="$store.getters['common/devices/typeById'](tr.new_device.type).icon"
                                                                  class="matched-device-info__type-icon"
                                                                  :svg-classes="[`text-${$store.getters['common/devices/typeById'](tr.new_device.type).icon_color}`]"
                                                                  :icon="$store.getters['common/devices/typeById'](tr.new_device.type).icon"/>
                                                    {{ $store.getters['common/devices/typeById'](tr.new_device.type).name }} <span>&nbsp;- {{tr.new_device.device_name}}&nbsp;</span>
                                                    <span class="matched-device-info__factory-number"> ({{ tr.new_device.factory_number ? tr.new_device.factory_number : 'Без номера' }})</span>
                                                </div>

                                            </div>
                                        </vs-td>
                                        <vs-td class="matched-devices-table__td matched-devices-table__td_dates">
                                            <div class="matched-device-info__dates">
                                                Ввод в эксплуатацию:  {{$parseDateFromString(tr.new_device.operation_start_date.date.split(' ')[0]) | moment}}
                                            </div>
                                            <div class="matched-device-info__dates">
                                                Следующая поверка:  {{$parseDateFromString(tr.new_device.next_checking_date.date.split(' ')[0]) | moment}}
                                            </div>
                                        </vs-td>
                                        <vs-td class="matched-devices-table__td matched-devices-table__td_start_value">
                                            <div class="w-full text-center">
                                                {{tr.new_device.start_value}}
                                            </div>

                                        </vs-td>
                                        <vs-td class="matched-devices-table__td matched-devices-table__td_actions">
                                            <div class="w-full flex justify-center">
                                                <div @click.stop.capture="setDeviceAction(tr.new_device, 'create')"
                                                     class="matched-devices-table__radio"
                                                     :class="[{
                                                         'matched-devices-table__radio_active': tr.new_device.action === 'create'
                                                     }]"
                                                />
                                            </div>
                                        </vs-td>

                                        <template slot="expand" @click="alert(213)">
                                            <h5 class="mb-2 w-full">Совпадающие приборы</h5>
                                            <vs-table :data="tr.exist_devices" class="w-full matched-devices-table_expand">
                                                <template slot="thead">
                                                    <vs-th class="matched-devices-table__td matched-devices-table__td_account-number">Л/С</vs-th>
                                                    <vs-th class="matched-devices-table__td matched-devices-table__td_device">Прибор</vs-th>
                                                    <vs-th class="matched-devices-table__td matched-devices-table__td_dates">Даты</vs-th>
                                                    <vs-th class="matched-devices-table__td matched-devices-table__td_start_value">
                                                        <div class="w-full text-center">
                                                            Начальное значение
                                                        </div>
                                                    </vs-th>
                                                    <vs-th class="matched-devices-table__td matched-devices-table__td_actions">
                                                        <div class="w-full text-center">
                                                            Заменить
                                                        </div>
                                                    </vs-th>
                                                </template>
                                                <template slot-scope="{data}" ref="content">
                                                    <vs-tr :key="indexExist" v-for="(trExist, indexExist) in data">
                                                        <vs-td class="matched-devices-table__td matched-devices-table__td_account-number">
                                                            {{trExist.account_number}}
                                                        </vs-td>
                                                        <vs-td class="matched-devices-table__td matched-devices-table__td_device">
                                                            <div class="matched-device-info">
                                                                <div class="matched-device-info__header">
                                                                    <feather-icon v-if="$store.getters['common/devices/typeById'](trExist.type).icon"
                                                                                  class="matched-device-info__type-icon"
                                                                                  :svg-classes="[`text-${$store.getters['common/devices/typeById'](trExist.type).icon_color}`]"
                                                                                  :icon="$store.getters['common/devices/typeById'](trExist.type).icon"/>
                                                                    {{ $store.getters['common/devices/typeById'](trExist.type).name }} <span>&nbsp;- {{trExist.device_name}}&nbsp;</span>
                                                                    <span class="matched-device-info__factory-number"> ({{ trExist.factory_number ? trExist.factory_number : 'Без номера' }})</span>
                                                                </div>

                                                            </div>
                                                        </vs-td>
                                                        <vs-td class="matched-devices-table__td matched-devices-table__td_dates">
                                                            <template v-if="trExist.operation_start_date || trExist.next_checking_date">
                                                                <div class="matched-device-info__dates" v-if="trExist.operation_start_date">
                                                                    Ввод в эксплуатацию:  {{$parseDateFromString(trExist.operation_start_date) | moment}}
                                                                </div>
                                                                <div class="matched-device-info__dates"  v-if="trExist.next_checking_date">
                                                                    Следующая поверка:  {{$parseDateFromString(trExist.next_checking_date) | moment}}
                                                                </div>
                                                            </template>
                                                            <div class="matched-device-info__dates" v-else>-</div>
                                                        </vs-td>
                                                        <vs-td class="matched-devices-table__td matched-devices-table__td_start_value">
                                                            <div class="w-full text-center">
                                                                {{trExist.start_value}}
                                                            </div>
                                                        </vs-td>
                                                        <vs-td class="matched-devices-table__td matched-devices-table__td_actions">
                                                            <div class="w-full flex justify-center">
                                                                <div @click.stop.capture="setDeviceAction(tr.new_device, `update-${trExist.id}`)"
                                                                     class="matched-devices-table__radio"
                                                                     :class="[{
                                                                        'matched-devices-table__radio_active': tr.new_device.action === `update-${trExist.id}`
                                                                     }]"
                                                                />
                                                            </div>
                                                        </vs-td>
                                                    </vs-tr>
                                                </template>
                                            </vs-table>
                                        </template>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </vs-collapse-item>
                        <vs-collapse-item>
                            <div slot="header">
                                <h5 class="flex items-center">
                                    <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger"/>
                                    Ошибок: {{matchedDevices.errors.length}}
                                </h5>
                            </div>
                            <div>
                                <table class="w-full" v-if="Array.isArray(matchedDevices.errors) && matchedDevices.errors.length">
                                    <thead>
                                        <tr>
                                            <th class="p-0">Строка</th>
                                            <th class="p-0">Столбец</th>
                                            <th class="p-0">Ошибка</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(error, index) in matchedDevices.errors" :key="`key-${index}`">
                                            <td>{{error.row}}</td>
                                            <td>{{error.column}}</td>
                                            <td>{{matchedDevices.err_codes[error.code]}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </vs-collapse-item>
                    </vs-collapse>
                    <div class="w-full flex justify-center mt-2">
                        <vs-button color="success" type="border" @click="solveDevices">Сохранить</vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import TranslitSettings from "./settings/TranslitSettings";
    export default {
        name: "UploadDevices",
        components: {TranslitSettings},
        data(){
          return {
              devicesFile: null,
              devicesNeedTranslit :true,
              matchedDevices: {},
              isMatchedDevicesOpen: false
          }
        },
        computed: {},
        methods: {
            changeDevicesFile(event, file){
                this.devicesFile = file[file.length-1];
            },
            deleteDevicesFile(){
                this.devicesFile = null;
            },
            solveDevices(){
                let devices = this.matchedDevices.matched_devices;
                let add = [];
                let update = [];

                devices.forEach((d, index) => {
                    let device = d.new_device;

                   if(device.action !== null){
                       if(device.action === 'create'){
                           add.push(index);
                       }
                       else{
                           let action = device.action.split('-');
                           update.push({
                               new_id: index,
                               old_id: action[1]
                           })
                       }
                   }
                });
                let params = {
                    solved: true,
                    add: JSON.stringify(add),
                    update: JSON.stringify(update)
                }

                this.importDevices(params);

            },
            async importDevices(params = {}){
                if(!this.devicesFile) return;
                let body = new FormData();
                body.append('devices_file', this.devicesFile);
                body.append('buildings_id', this.$store.getters['appUser/selectedHouse'].id);
                body.append('users_id', this.$store.getters['appUser/id']);
                body.append('need_translit', this.devicesNeedTranslit);

                for (let prop in params) {
                    body.append(prop, params[prop]);
                }


                this.$vs.loading({type:'default'});
                try {
                    let {data} = await this.$http.post('import/devices', body);

                    if (data === 'error') {
                        this.$vs.notify({color: 'danger', title: 'Ошибка загрузки', text: 'Файл не загружен'})
                    }
                    else if(data.hasOwnProperty('matched_devices')){
                        this.matchedDevices = data;
                        this.matchedDevices.matched_devices.forEach(device => {
                            this.$set(device.new_device, 'action', null);
                        });
                        this.isMatchedDevicesOpen = true;
                        this.$nextTick(()=> {
                            this.updateMutations();
                        });
                    } else {
                        this.isMatchedDevicesOpen = false;
                        this.$emit('uploaded', {info: data});
                        this.$vs.notify({color: 'success', title: 'Импорт завершен', text: 'Файл импортирован'});
                        this.resetFile();
                    }
                }
                catch(e){
                    if (e.response) {
                        if(e.response.status === 403){
                            this.$vs.notify({color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав'});
                        }
                        else{
                            this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже'});
                        }
                    }
                    else{
                        this.$vs.notify({color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка'});
                    }
                }
                finally {
                    this.$vs.loading.close();
                }
            },
            updateDevicesImportHeight(){
                this.$emit('openExtraSettings');
            },
            resetFile(){
                this.devicesFile = null;
                this.$refs.devicesUploader.srcs = [];
                this.$refs.devicesUploader.itemRemove = [];
                this.$refs.devicesUploader.filesx = [];
            },
            updateDevicesCollapseHeight(){
                setTimeout(this.$refs.matchedDevicesCollapse.changeHeight, 0);
            },
            setDeviceAction(device, action){
                this.$set(device, 'action', device.action === action ? null : action);
            },
            updateMutations(){
                let table = document.querySelector('.matched-devices-table');
                this.observer = new MutationObserver(mutations => {
                    for (const m of mutations) {
                        this.$nextTick(() => {
                            this.updateDevicesCollapseHeight();
                        });
                    }
                });
                this.$nextTick(() => {
                    let trs = table.querySelectorAll('tr.vs-table--tr');
                    trs.forEach(tr => {
                        this.observer.observe(tr, {
                            attributes: true,
                            attributeOldValue : true,
                            attributeFilter: ['class'],
                        });
                    });
                });
            }
        },
        mounted() {
        },
        watch: {}
    }
</script>

<style lang="scss">
    .devices-import-matched-answer-collapse{
        padding: 0;

        .vs-collapse-item--header{
            padding: 5px 1rem 1rem 0;
            font-size: 1rem;
        }

        .con-content--item{
            padding: 10px 0!important;
        }

        .td-check{
            width: 1%;
        }
    }

    .matched-device-info{
        &__header{
            display: flex;
            align-items: center;
            font-weight: 500;
            white-space: nowrap;
            svg{
                width: 16px;
                height: 16px;
            }
        }

        &__factory-number{
            font-weight: 400;
        }

        &__type-icon{
            margin-right: 5px;
        }

        &__dates{
            font-size: 0.9rem;
            white-space: nowrap;
        }
    }

    .matched-devices-table{
        .content-tr-expand{
            padding: 10px 0 10px 10px!important;
            flex-direction: column!important;
            border-bottom: 1px solid #ccc!important;
        }

        &_expand{
            padding-left: 20px;
            .vs-table--tbody{
                border: none!important;
            }
        }

        &__td{
            &_account-number{
                width: 130px;
            }

            &_device{
                width: 100%;
            }

            &_dates{
                width: 240px;
            }

            &_start_value{
                width: 100px;
            }

            &_actions{
                width: 90px;
                display: inline-block;
            }
        }

        &__radio{
            width: 18px;
            height: 18px;
            position: relative;
            display: block;
            cursor: pointer;
            &::after{
                content: "";
                display: block;
                width: 100%;
                height: 100%;
                position: absolute;
                border-radius: 50%;
                left: 0;
                transition: all .25s ease;
                top: 0;
                border: 2px solid rgb(200, 200, 200);
                box-sizing: border-box;
            }

            &_active{
                &::after{
                    border: none;
                    box-shadow: 0 3px 12px 0 rgba(var(--vs-primary),0.4);
                    background: rgba(var(--vs-primary),1);
                }
            }
        }
    }

    .devices-import-matched-answer-popup{
        .vs-popup{
            width: 800px;
        }
    }
</style>
